export default "__VITE_ASSET__ccab9d80__"